import { Operation } from '../../../__generated__/globalTypes'

import {
  MinimalContactFragment,
  minimalContactFragmentString,
} from '../../fragments/__generated__/MinimalContactFragment'

import getAllContactsRawString from '../GetAllContacts.graphql'

const getAllContactsString = [
  getAllContactsRawString,
  minimalContactFragmentString,
].join('\n\n')

export type GetAllContactsData = {
  paginatedContacts: {
    allContacts: MinimalContactFragment[]
  }
}

export type GetAllContacts = Operation<GetAllContactsData>

export const GetAllContacts = (): GetAllContacts => ({
  query: getAllContactsString,
  variables: undefined,
})
